module.exports = {
	"en": {
		"answers": [
			"Strongly agree",
			"Rather agree",
			"Rather disagree",
			"Strongly disagree"
		],
		"questions": [
			{
				"text": "I want others to recognize the jewelry brand (e.g., Cartier, Tiffany) I wear"
			},
			{
				"text": "I only buy precious jewelry from trusted jewelry stores (e.g. Tanishq, Orra, Hazoorilal, TBZ, Notandas, GRT, Joyallukas, Kalyan)\n[if ‘Receiver only’]:\nI prefer precious jewelry from trusted jewelry stores (e.g. Tanishq, Orra, Hazoorilal, TBZ, Notandas, GRT, Joyallukas, Kalyan)"
			},
			{
				"text": "I prefer -precious jewelry from well-known brands, because I can trust the quality"
			},
			{
				"text": "I would rather save money on the metal, to allow more to spend on the stone (e.g., diamond)."
			},
			{
				"text": "Precious jewelry is approporiate to celebrate the major milestones and important memories in my life"
			},
			{
				"text": "I wear the same jewelry for years"
			},
			{
				"text": "Precious jewelry is valuable and maintains its value"
			},
			{
				"text": "Luxury products help me to set myself apart from average people"
			},
			{
				"text": "I only buy expensive jewelry for special occasions (e.g., wedding, engagement, anniversary, christmas or personal milestone).\n[if ‘Receiver only’]:\nFor special occasions (e.g., wedding, engagement, anniversary, christmas or personal milestone) I love to receive precious jewelry as a gift"
			},
			{
				"text": "Jewelry made of precious metals is a stable investment asset"
			},
			{
				"text": "When it comes to a wedding or engagement, price doesnt matter - Most important is that the bride likes the jewelry"
			},
			{
				"text": "Even if in small numbers, I prefer to own precious jewelry made of high quality metal"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/lang.json
// module id = 605
// module chunks = 0